// Browsers
export const CHROME_BROWSER = 'chrome'
export const FIREFOX_BROWSER = 'firefox'
export const UNSUPPORTED_BROWSER = 'other'

// localStorage keys
export const STORAGE_REFERRAL_DATA_REFERRING_USER =
  'tab.referralData.referringUser'
export const STORAGE_REFERRAL_DATA_REFERRING_CHANNEL =
  'tab.referralData.referringChannel'



// WEBPACK FOOTER //
// ./src/utils/constants.js